import type { CSSProperties } from 'react';
import styled from 'styled-components';

export const DropdownContainer = styled.div.attrs({
  className:
    'absolute z-50 max-h-60 min-w-40 max-w-[80dvw] overflow-auto break-words rounded-md border bg-popover p-1 shadow-md',
})``;

export const DropdownMessage = styled.p.attrs({
  className: 'px-2 py-1.5 text-sm text-muted-foreground',
})``;

export function dropdownBoxStyle(
  maxHeight?: number,
  position?: { top: number; left: number }
): CSSProperties | undefined {
  if (maxHeight == null && position == null) return undefined;
  return { ...(maxHeight != null ? { maxHeight } : {}), ...(position ?? {}) };
}
